<template src="./BrandBrand.html"></template>

<script>
import axios from 'axios'

const c3 = require('c3')

import Back from '@/components/Dashboard/Back'
import Searchfield from '@/components/Dashboard/Searchfield'
import Settings from '@/components/Dashboard/Settings'
import Years from '@/components/Dashboard/Years'

export default {
  name: 'brandbrand',
  components: { Back, Searchfield, Settings, Years },
  data () {
    return {
      years: this.$parent.years,
      year: '',
      atgs: [],
      tmpAtgs: [],
      showmore: false,
      sort: 'revenues',
      link: '/dashboard/statistics/brands/' + this.$route.params.year,
      searchword: '',
      mode: '1',
      sum: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    }
  },
  mounted: function() {
    this.year = this.$route.params.year

    this.fetchData()
  },
  methods: {
    dateRedirect: function() {
      this.$router.push('/dashboard/statistics/brands/' + this.year)
      this.fetchData()
    },
    reduceList: function(searchword) {
      if(this.tmpAtgs.length==0) {
        this.tmpAtgs = this.atgs
      }

      if(searchword!="") {

        this.atgs = this.atgs.filter(function(cat) {        
          return cat.name.toLowerCase().indexOf( searchword.toLowerCase())>=0
        })

      } else {

        this.atgs = this.tmpAtgs

      }
    },
    fetchData: function() {
      this.$parent.loader = 1
      
      var url = this.$serviceurl + 'statistik/umsatz/marken/kunde/' + localStorage.getItem('ext-kunde') + '/marke/' + this.$route.params.brand;
      let headers = { 
        'Access-Control-Allow-Origin': '*', 
        'Accept': 'application/json', 
        'app-version': '2.2', 
        'token' : localStorage.getItem('ext-token') 
      };
      let options = { 
        headers: headers
      };

      axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(response => {
        this.atgs = response.data;        
        if(this.modus=='top') {
          this.atgs = this._.orderBy(this.atgs, ['umsatzLj'], ['desc']);
        }
        if(this.modus=='flop') {
          this.atgs = this._.orderBy(this.atgs, ['umsatzLj'], ['asc']);
        }  
        /*this.loaderSm = false;*/
        this.drawChart()
        this.$parent.loader = 0
        if(this.searchword!="") this.reduceList(this.searchword)
      })
      .catch(e => {
        //console.log(e)
      })
    },
    drawChart: function() {
      var dataLj = [
        [],
        [],
        [],
        [],
        [],
        []
      ];

      var columnsArr = [];

      var showChart = false

      for (var index = 0; index < this.atgs.length; index++) {
        if(index<5) {
          if(this.mode=='1') {
            columnsArr.push([this.atgs[index].name, this.atgs[index].umsatzLj]);
          }else{
            columnsArr.push([this.atgs[index].name, this.atgs[index].umsatzLj]);
          }    
          if(this.atgs[index].umsatzLj > 0) {
            showChart = true
          }
          dataLj[0].push(this.atgs[index].id);
          dataLj[1].push(this.atgs[index].name);
          dataLj[2].push(this.atgs[index].umsatzLj);
          dataLj[3].push(this.atgs[index].umsatzVj);
          dataLj[4].push(this.atgs[index].erloesLj);
          dataLj[5].push(this.atgs[index].erloesVj);
        }
      }

      let sumArray = this._.slice(this.atgs, 5)
      let sum = this._.sumBy(sumArray,'umsatzLj')
      this.sum = sum

      var greys = ['#878787','#9d9d9c','#b2b2b2','#dadada','#ededed'];
      var colors = ['#003366','#1d71b8','#00a19a','#66aa66','#006633'];
      var mixed = [];

      if(showChart) {
        var pie_chart = c3.generate({
          bindto: "#yCustomerChart",
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type : 'pie'
          }
        });
      } else {
        $("#yCustomerChart" + this.mode).html('')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// BrandBrand.vue?1a727f06